import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import siteReducer from "./reducers/siteReducer";

export default configureStore({
  reducer: {
    auth: authReducer,
    site: siteReducer,
  },
});
